/* eslint-disable react/no-array-index-key */
import React, { PureComponent } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import FormInput from '../Generals/FormInput/FormInput';
import {
  LoginItemWrap,
  LoginItem,
  LoginPasswordAction,
  ButtonStyled,
  LoginErrorMessage,
} from '../LoginPage/Login.style';
import { Arrow, Paragraph, Title } from '../LoginPage/SignUpType.style';

const validationSchema = Yup.object().shape({
  firstName: Yup.string().trim().required('First name is required'),
  lastName: Yup.string().trim().required('Last name is required'),
  email: Yup.string().email('Enter a valid email address').trim().required('Email address is required'),
  sectionCode: Yup.string().trim().required('Section code is required'),
  grade: Yup.string().ensure().required('Section Grade is required!'),
  password: Yup.string()
    .trim()
    .notOneOf(['123456', 123456], 'Your password is too simple')
    .min(8, 'Password must be a minimum of 8 characters long')
    .matches(/[0-9]/, 'The password contains at least one number')
    .required('Password is required'),
  confirmPassword: Yup.string()
    .oneOf(
      [Yup.ref('password'), null],
      'Your password and confirm password is not match',
    )
    .required('Please confirm your password'),
});

const initialValues = {
  firstName: '',
  lastName: '',
  email: '',
  sectionCode: '',
  password: '',
  confirmPassword: '',
  grade: '',
};

const gradeOption = [];
for (let i = 3; i <= 12; i++) {
  gradeOption.push(
    {
      id: `${i-2}`,
      grade_level: `${i}`,
    }
  );
}

export default class StudentRegisterForm extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isShowPassword: false,
      gitMessage: false,
    };
  }

  static propTypes = {
    isLoading: PropTypes.bool,
    registerStudent: PropTypes.func.isRequired,
    errorMessage: PropTypes.any,
  };

  state = {
    isShowPassword: false,
    gitMessage: false,
  };

  toggleShowPassword = (isShowPassword) => {
    this.setState({
      isShowPassword,
    });
  };

  registerStudent = (values) => {
    const { registerStudent } = this.props;
    registerStudent(values);
    this.setState({ gitMessage: true });
  };

  renderPasswordAction = () => (
    <LoginPasswordAction>
      <label>
        <input type="checkbox" />
        <span className="checkmark" />
        <span>Remember me</span>
      </label>
    </LoginPasswordAction>
  );

  renderLoginBtn = () => {
    const { isLoading } = this.props;
    return isLoading ? (
      <ButtonStyled primary>Loading ...</ButtonStyled>
    ) : (
      <ButtonStyled type="submit">Create account</ButtonStyled>
    );
  };

  renderErrorMessage = (error, index) => {
    if (this.state.gitMessage) {
      return (<p key={index}>{error}</p>);
    }
  }



  componentDidMount() {
    this.setState({ gitMessage: false });
  }

  render() {
    const { errorMessage } = this.props;
    const { isShowPassword } = this.state;

    return (
      <LoginItemWrap>
        <LoginItem>
          <Link to="/login" aria-label="Back to login">
            <Arrow src="/images/left.png" alt="" />
          </Link>
          <Title>Welcome to ChalkTalk</Title>
          <Paragraph>
            <br />
            ChalkTalk will help you to boost your grades!
          </Paragraph>
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={this.registerStudent}
          >
            <Form noValidate>
              <FormInput type="text" name="firstName" label="First Name" autoComplete="given-name" />
              <FormInput type="text" name="lastName" label="Last Name" autoComplete="family-name" />
              <FormInput type="email" name="email" label="Email" autoComplete="email" />
              <FormInput type="text" name="sectionCode" label="Section Code" />
              <FormInput
                type="select"
                name="grade"
                label="Section Grade"
                options={gradeOption}
                getOptionValue={(option) => option.id}
                getOptionLabel={(option) => option.grade_level}
              />
              <FormInput
                type={isShowPassword ? 'text' : 'password'}
                name="password"
                label="Password"
                autoComplete="new-password"
              />
              <FormInput
                type="password"
                name="confirmPassword"
                label="Confirm Password"
                autoComplete="new-password"
              />
              {this.renderPasswordAction()}
              {errorMessage && (
                <LoginErrorMessage>
                  {errorMessage.map(this.renderErrorMessage)}
                </LoginErrorMessage>
              )}
              {this.renderLoginBtn()}
            </Form>
          </Formik>
        </LoginItem>
      </LoginItemWrap>
    );
  }
}
